import React, { ReactElement } from "react";
import GlobalCategoryDetails from "../../components/GlobalCategory/Details";
import Layout from "../../components/layout";

const GlobalCategoryDetailsPage = (): ReactElement => {
  return (
    <Layout>
      <GlobalCategoryDetails />
    </Layout>
  );
};

export default GlobalCategoryDetailsPage;
